// removed by extract-text-webpack-plugin
module.exports = {"container":"container__3jA1d","small":"small__1TQEN","medium":"medium__2rBUY","content":"content__1GTN3","picture":"picture__38c-q","left":"left__1EhPD","right":"right__1O986","large":"large__2yrNd","big":"big__3CGHu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Image/styles.scss
// module id = 250
// module chunks = 0